module.exports = __webpack_public_path__ + "img/offers.weekly.04fc3110.png";